import React from 'react';
import MinimizeArrowImg from 'Assets/images/pages/web-chat/minimize-arrow.svg';
import MinimizeCancelImg from 'Assets/images/pages/web-chat/fullscreen.svg';
import MuteImg from 'Assets/images/pages/web-chat/muted.svg';
import FlipImg from 'Assets/images/pages/web-chat/flip.svg';
import SoundImg from 'Assets/images/pages/web-chat/sound-wave.svg';
import { bool, func, node, string } from 'prop-types';
import { Image, Popup } from 'semantic-ui-react';

import ControlButton from '../ControlButton/ControlButton';

import css from './VideoHeader.less';

function VideoHeader({
  avatar,
  name,
  isMuted,
  isMinimized,
  setIsMinimized,
  flip,
  setFlip,
  speaking,
}) {
  return (
    <div className={css.container} id="test-poper">
      <div className={css.ava}>{avatar}</div>
      <div className={css.doctorName}>
        {name}
        {isMuted && (
          <Popup
            content={`${name}’s microphone is off`}
            position="bottom center"
            popper={{ id: 'video-header-container', style: { zIndex: 200000 } }}
            trigger={
              <div className={css.muted}>
                <img src={MuteImg} alt="Mute" />
              </div>
            }
          />
        )}
        {speaking && <Image src={SoundImg} className={css.wave} />}
      </div>
      <div className={css.controlItem}>
        <Popup
          popper={{ id: 'test-poper', style: { zIndex: 200000 } }}
          position="bottom center"
          content="Flip video horizontal"
          on="hover"
          trigger={
            <div>
              <ControlButton
                icon={FlipImg}
                background="transparent"
                onClick={() => {
                  setFlip(!flip);
                }}
              />
            </div>
          }
        />

        <ControlButton
          icon={isMinimized ? MinimizeCancelImg : MinimizeArrowImg}
          background="transparent"
          onClick={() => {
            setIsMinimized(!isMinimized);
          }}
        />
      </div>
    </div>
  );
}

VideoHeader.propTypes = {
  avatar: node.isRequired,
  name: string.isRequired,
  isMinimized: bool.isRequired,
  setIsMinimized: func.isRequired,
  isMuted: bool,
  flip: bool.isRequired,
  speaking: bool.isRequired,
  setFlip: func.isRequired,
};

VideoHeader.defaultProps = {
  isMuted: false,
};

export default VideoHeader;
